(function () {
  // ---- Polyfills for older mobile / in-app browsers ----
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }
  if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
      var el = this;
      while (el && el.nodeType === 1) {
        if (el.matches(s)) return el;
        el = el.parentElement || el.parentNode;
      }
      return null;
    };
  }
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }

  var ROOT = '[data-measurements-form]';
  var SAVE = '[data-measurements-save]';
  var INPUT = '[data-measurement-input]';

  // ---- Helpers ----
  function getValue(input) {
    // Some keyboards enter "72,5" instead of "72.5"
    return input.value.trim().replace(',', '.');
  }

  function setStatus(root, message, type, isHtml) {
    var status = root.querySelector('[data-measurements-status]');
    if (!status) return;
    status.className = 'measurements__status' + (type ? ' is-' + type : '');
    if (isHtml) {
      status.innerHTML = message;
    } else {
      status.textContent = message;
    }
  }

  function setFieldError(input, message) {
    var field = input.closest('.measurements__field');
    if (!field) return;
    field.classList.add('is-error');
    var errorEl = field.querySelector('[data-field-error]');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'measurements__field-error';
      errorEl.setAttribute('data-field-error', '');
      field.appendChild(errorEl);
    }
    errorEl.textContent = message;
  }

  function clearFieldError(input) {
    var field = input.closest('.measurements__field');
    if (!field) return;
    field.classList.remove('is-error');
    var errorEl = field.querySelector('[data-field-error]');
    if (errorEl && errorEl.parentNode) errorEl.parentNode.removeChild(errorEl);
  }

  function getRangeMessage(min, max) {
    if (min !== null && max !== null) return 'Must be between ' + min + ' - ' + max + '.';
    if (min !== null) return 'Must be at least ' + min + '.';
    return 'Must be at most ' + max + '.';
  }

  // Returns true if valid. showRequired = false while typing, true on blur/save.
  function validateInput(input, showRequired) {
    var value = getValue(input);
    var min = input.getAttribute('data-min');
    var max = input.getAttribute('data-max');
    var message = '';

    if (!value) {
      if (input.hasAttribute('required') && showRequired) message = 'This field is required.';
    } else {
      var num = Number(value);
      if (isNaN(num)) {
        message = 'Enter a valid number.';
      } else if ((min !== null && num < parseFloat(min)) || (max !== null && num > parseFloat(max))) {
        message = getRangeMessage(min, max);
      }
    }

    if (message) {
      setFieldError(input, message);
    } else {
      clearFieldError(input);
    }

    return !message;
  }

  function hasRequiredError(root) {
    return !!root.querySelector('.measurements__field.is-error ' + INPUT + '[required]');
  }

  function updateButtonState(root) {
    var button = root.querySelector(SAVE);
    if (!button || root.getAttribute('data-saving') === 'true') return;
    button.disabled = hasRequiredError(root);
  }

  function clearStatusIfValid(root) {
    if (!root.querySelector('.measurements__field.is-error')) setStatus(root, '', '');
  }

  function handleFieldChange(input, showRequired) {
    var root = input.closest(ROOT);
    if (!root) return;
    validateInput(input, showRequired);
    clearStatusIfValid(root);
    updateButtonState(root);
  }

  function setLoading(root, button, isLoading) {
    if (isLoading) {
      root.setAttribute('data-saving', 'true');
    } else {
      root.removeAttribute('data-saving');
    }
    if (!button) return;
    button.disabled = isLoading;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  // XHR works in every mobile / in-app browser.
  // text/plain = no CORS preflight (Safari is strictest about preflights).
  function postJSON(url, payload, onSuccess, onError) {
    var xhr = new XMLHttpRequest();
    var done = false;

    function finish(fn, arg) {
      if (done) return;
      done = true;
      fn(arg);
    }

    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
    xhr.timeout = 20000;

    xhr.onload = function () {
      var data = {};
      try { data = JSON.parse(xhr.responseText || '{}'); } catch (err) {}

      if (xhr.status >= 200 && xhr.status < 300 && data.ok === true) {
        finish(onSuccess, data);
      } else {
        finish(onError, new Error(data.message || data.error || ('Request failed (' + xhr.status + ')')));
      }
    };
    xhr.onerror = function () {
      finish(onError, new Error('Network error (status ' + xhr.status + ')'));
    };
    xhr.ontimeout = function () {
      finish(onError, new Error('Request timed out'));
    };

    xhr.send(JSON.stringify(payload));
  }

  // ---- Save ----
  function saveMeasurements(root) {
    if (root.getAttribute('data-saving') === 'true') return;

    var button = root.querySelector(SAVE);
    var saveUrl = root.getAttribute('data-save-url');
    var customerId = root.getAttribute('data-customer-id');
    var measurements = [];
    var hasError = false;

    setStatus(root, '', '');

    root.querySelectorAll(INPUT).forEach(function (input) {
      if (!validateInput(input, true)) {
        hasError = true;
        return;
      }
      var value = getValue(input);
      if (value) measurements.push({ name: input.name, value: Number(value) });
    });

    if (hasError) {
      var errorTemplate = document.getElementById('measurements_error');
      var errorMsg = errorTemplate ? errorTemplate.innerHTML : 'Please fix the highlighted fields.';
      setStatus(root, errorMsg, 'error', true);
      updateButtonState(root);
      var firstError = root.querySelector('.measurements__field.is-error ' + INPUT);
      if (firstError) firstError.focus();
      return;
    }

    if (!measurements.length) {
      setStatus(root, 'Please enter at least one measurement.', 'error');
      return;
    }

    if (!saveUrl || !customerId) {
      setStatus(root, 'Save endpoint is not configured.', 'error');
      return;
    }

    // Close the mobile keyboard so the status message is visible
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();

    setLoading(root, button, true);

    postJSON(
      saveUrl,
      { customerId: customerId, measurements: measurements },
      function () {
        // Reload ONLY after the Worker confirms the save
        setStatus(root, 'Measurements saved.', 'success');
        if (button) button.setAttribute('aria-busy', 'false');
        document.body.classList.add('is-loading');
        setTimeout(function () {
          window.location.reload();
        }, 1500);
      },
      function (err) {
        console.log('SAVE ERROR:', err.message);
        setLoading(root, button, false);
        setStatus(root, 'Could not save: ' + err.message, 'error');
        updateButtonState(root);
      }
    );
  }

  // ---- Events ----

  // Tapping Save blurs the input first; skip blur validation so the layout
  // doesn't shift under the finger and swallow the tap.
  var savePressed = false;
  function markSavePress(e) {
    savePressed = !!(e.target && e.target.closest && e.target.closest(SAVE));
  }
  document.addEventListener('pointerdown', markSavePress);
  document.addEventListener('touchstart', markSavePress, { passive: true });
  document.addEventListener('mousedown', markSavePress);

  // Instant validation while typing
  document.addEventListener('input', function (e) {
    var input = e.target && e.target.closest && e.target.closest(INPUT);
    if (input) handleFieldChange(input, false);
  });

  // On leaving the field, also flag empty required fields
  document.addEventListener('focusout', function (e) {
    var input = e.target && e.target.closest && e.target.closest(INPUT);
    if (input && !savePressed) handleFieldChange(input, true);
  });

  // Save button click (capture phase, so nothing else can submit/reload first)
  document.addEventListener('click', function (e) {
    var button = e.target && e.target.closest && e.target.closest(SAVE);
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();
    savePressed = false;
    var root = button.closest(ROOT);
    if (root) saveMeasurements(root);
  }, true);

  // Enter / "Go" key inside a measurement field saves instead of submitting
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.keyCode !== 13) return;
    var input = e.target && e.target.closest && e.target.closest(INPUT);
    if (!input) return;
    var root = input.closest(ROOT);
    if (!root) return; // not the account measurements form (e.g. product-page custom sizes)
    e.preventDefault();
    saveMeasurements(root);
  }, true);

  // Safety net: block native submit only for the measurements form itself
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches) return;
    var root = form.matches(ROOT) ? form : form.querySelector(ROOT);
    if (!root) return;
    e.preventDefault();
    saveMeasurements(root);
  }, true);
})();

// ===================================================================================
document.addEventListener("variant:changed", function (event) {
  if (event.detail.variant) {
    if (event.detail.variant.title == "Custom Size") {
      $('#no-login_skip-custom-size-popup').attr('open', '');
    }
  }
});
$('body').on('click', '.no-login_skip-custom-size-popup_button-skip,.no-login_skip-custom-size-modal__close-button', function (e) {
  e.preventDefault();
  $('.no-login-redirect-login-page-wrapper').removeAttr('hidden');
  $('#no-login_skip-custom-size-popup').removeAttr('open');
  $('body').removeClass('lock-all');
});
// ==========================================================================
function initSizeRecommender() {

  function normalize(str) {
    return String(str || '').trim().toLowerCase();
  }

  function extractSizeCode(label) {
    const match = String(label).match(/\(([^)]+)\)/);
    return match ? match[1] : String(label).trim();
  }

  // "24" -> {min:24, max:24} | "30-32" -> {min:30, max:32}
  function parseRange(cell) {
    const parts = String(cell).split(/\s*[-–]\s*/).map(parseFloat);
    const a = parts[0];
    const b = parts.length > 1 ? parts[1] : parts[0];
    if (isNaN(a) || isNaN(b)) return null;
    return { min: Math.min(a, b), max: Math.max(a, b) };
  }

  function recommend(data) {
    const sizes = (data.header || '').split(',').map(s => s.trim()).slice(1);
    const tolerance = typeof data.tolerance === 'number' ? data.tolerance : 0.5;

    const customer = {};
    (data.customer || []).forEach(function (m) {
      const v = parseFloat(m.value);
      if (!isNaN(v)) customer[normalize(m.name)] = v;
    });

    const rows = (data.rows || [])
      .map(function (row) {
        const cells = row.split(',').map(s => s.trim());
        return { name: cells[0], values: cells.slice(1).map(parseRange) };
      })
      .filter(function (r) { return r.name; });

    if (!rows.length || !Object.keys(customer).length) return null;

    for (let i = 0; i < sizes.length; i++) {
      const match = rows.every(function (r) {
        const cust = customer[normalize(r.name)];
        const range = r.values[i];
        return cust !== undefined && range &&
          cust >= range.min - tolerance &&
          cust <= range.max + tolerance;
      });
      if (match) return extractSizeCode(sizes[i]);
    }
    return null;
  }

  $('[data-size-recommender]').each(function () {
    const $root = $(this);
    const $fit = $root.find('.product-meta-idea_fit');
    let data;

    let $data = $root.find('.size-recommender__data');
    if (!$data.length) $data = $('.size-recommender__data');

    try {
      data = JSON.parse($data.first().text());
    } catch (e) {
      console.warn('Size recommender: invalid JSON', e);
      return;
    }

    const size = recommend(data);
    $fit.removeClass('matched');

    if (size) {
      $fit.addClass('matched').html(`Ideal Fit - ${size}`);
    }
    // else {
    //   $fit.addClass('product-meta-idea_fit--custom')
    //     .html('<span class="product-meta-idea_fit--text">For the most accurate fit, we recommend choosing Custom Sizing.</span>');
    // }
  });

  setTimeout(function () {
    $('.size-recommender').removeAttr('hidden');
  }, 200);
}

initSizeRecommender();

document.addEventListener('variant:changed', function () {
  setTimeout(initSizeRecommender, 100);
}); 
// ===================================================================================
$('body').on('click', '.save-fit_button', function (e) {
  e.preventDefault();

  var $button = $(this);
  var $wrapper = $button.closest('.custom_sizes');
  var $inputs = $wrapper.find('[data-measurement-input]');

  // Check if saved values are currently applied
  var isSaved = $button.hasClass('is-saved');

  if (!isSaved) {
    // Apply saved values
    $inputs.each(function () {
      var $input = $(this);
      var savedValue = $input.attr('data-value');

      if (savedValue !== undefined && savedValue !== '') {
        $input.val(savedValue);
        $input.prop('readonly', true);
      }
    });

    $button.text('Add Custom Measurements').addClass('is-saved');

  } else {
    // Remove saved values and allow custom input
    $inputs.each(function () {
      var $input = $(this);

      $input.val('');
      $input.prop('readonly', false);
    });

    $button.text('Use Saved Fit').removeClass('is-saved');
  }
});